import { toast } from 'react-toastify';

export const errorMessage = (err) => {
  // Se não houver respostar do servidor
  if (!err.response) {
    return toast.error(err);
  }

  let message;

  // Resposta do servidor
  if (err.response.statusText) message = err.response.statusText;
  if (err.response.data && err.response.data instanceof String)
    message = err.response.data;
  if (err.response.data.error) message = err.response.data.error;

  toast.error(message);
};
